Jelly.Interface.Sort = function(Parameters) {	
	// Sort list by data attribute
	// List_Element, Data_Attribute
	// Optional: List_Item_Sector, Order
	
	$(Parameters["List_Element"]).children().sort(function(An_Element, Another_Element) { 
		var A_Test_Element = (Parameters["List_Item_Selector"] ? $(An_Element).find(Parameters["List_Item_Selector"]) : $(An_Element));
		var Another_Test_Element = (Parameters["List_Item_Selector"] ? $(Another_Element).find(Parameters["List_Item_Selector"]) : $(Another_Element));
		return ( A_Test_Element.data(Parameters["Data_Attribute"]) >  Another_Test_Element.data(Parameters["Data_Attribute"]) ? 
			(!Parameters["Order"] && Parameters["Order"].toLowercase() == "ascending" ? 1 : -1)
			: 
			(!Parameters["Order"] && Parameters["Order"].toLowercase() == "ascending" ? -1 : 1)
		);
	}).detach().appendTo(Parameters["List_Element"]);
};
